"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Switch = _interopRequireDefault(require("../../../components/Switch"));
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _BlockContent = _interopRequireDefault(require("../../../components/BlockContent"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var _theme = require("../../../theme");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
var _services = require("../../../services");
var localizationMaps = _interopRequireWildcard(require("../../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LTD = /*#__PURE__*/function (_Component) {
  function LTD() {
    var _this;
    (0, _classCallCheck2["default"])(this, LTD);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, LTD, [].concat(args)), _this.state = {
      data: null
    }, _this._setData = function (data) {
      var defaults = {
        isSelected: data.isSelected || false,
        isGraded: data.isGraded === undefined ? true : data.isGraded,
        isFlatAmount: data.isFlatAmount || false,
        isTaxable: data.isTaxable || false,
        includeAllowPreExistingConditions: data.includeAllowPreExistingConditions || false,
        includeCostOfLivingAdjustments: data.includeCostOfLivingAdjustments || false,
        costOfLivingAdjustmentsPercentage: data.costOfLivingAdjustmentsPercentage || 3,
        includeLumpSumPaymentDisabledParticipantsDeath: data.includeLumpSumPaymentDisabledParticipantsDeath || false,
        percentageOfFlatAmount: typeof data.percentageOfFlatAmount === "number" ? data.percentageOfFlatAmount : 66.67,
        maxNoEvidence: data.maxNoEvidence || 0,
        maxEvidence: data.maxEvidence || 0,
        benefitsPeriod: data.benefitsPeriod || 'To Age 65',
        elimPeriod: data.elimPeriod ? parseInt(data.elimPeriod, 10) : 119,
        defOfDisability: data.defOfDisability || "2 Year Own Occupation, Any Occupation Thereafter",
        firstMaxType: data.firstMaxType || 'Dollar Amount',
        secondMaxType: data.secondMaxType || 'Dollar Amount',
        thirdMaxType: data.thirdMaxType || 'Remainder',
        percentageFirstMax: data.percentageFirstMax || 0,
        percentageSecondMax: data.percentageSecondMax || 0,
        percentageThirdMax: data.percentageThirdMax || 0,
        firstMax: data.firstMax || 0,
        secondMax: data.secondMax || 0,
        thirdMax: data.thirdMax || 0,
        terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
        eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
        minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
        notes: data.notes || null
      };
      _this.setState({
        data: _objectSpread({}, defaults)
      });
      return defaults;
    }, _this._handleChange = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      _this.setState({
        data: _objectSpread(_objectSpread({}, _this.state.data), {}, (0, _defineProperty2["default"])({}, field, value))
      });
    }, _this._saveInGlobalState = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      if (field === 'notes' && value.toString().length === 0) {
        value = null;
      }
      if (_this.props.type === "modular") {
        _this.props.saveModularField(_this.props.classID, null, null, 'ltd', field, value);
      } else {
        _this.props.savePlanDesignField(_this.props.selectedClassID, _this.props.selectedDesignID, 'ltd', field, value);
      }
      _this.props.setChangesMadeFlag();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(LTD, _Component);
  return (0, _createClass2["default"])(LTD, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var defaults = this._setData(this.props.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        // tier, tierBenefit, benefit, data

        // save the init data in global state so it's there for the save
        this.props.saveModularBenefitInitData(this.props.classID, null, null, 'ltd', defaults);
        return;
      }

      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'ltd', defaults);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var defaults = this._setData(nextProps.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        return;
      }
      if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
        // save the init data in global state so it's there for the save
        this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'ltd', defaults);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.data) {
        return null;
      }
      var _this$props = this.props,
        classes = _this$props.classes,
        errors = _this$props.errors,
        whitelabel = _this$props.whitelabel,
        isMasterSite = _this$props.isMasterSite,
        revision = _this$props.revision,
        isRevisionBlock = _this$props.isRevisionBlock;
      var data = this.state.data;
      var isSelected = Boolean(data.isSelected);
      return /*#__PURE__*/_react["default"].createElement(_BlockContent["default"], {
        style: isRevisionBlock ? {
          backgroundColor: '#F7F9FA'
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], {
        style: {
          borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, revision ? isRevisionBlock ? "".concat(_i18n["default"].t(_tokens["default"].titles.longTermDisability), " (").concat(revision.revisionID, ")") : _i18n["default"].t(_tokens["default"].labels.planDesign.longTermDisabilityCurrent) : _i18n["default"].t(_tokens["default"].titles.longTermDisability)), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: data.isSelected,
        onChange: function onChange() {
          return _this2._saveInGlobalState("isSelected", !isSelected);
        }
      })), isSelected && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: 20,
          paddingBottom: 50
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectBetween)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.gradedAmount),
          selected: data.isGraded,
          field: 'isGraded'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.flatAmount),
          selected: data.isFlatAmount,
          field: 'isFlatAmount'
        },
        handleChange: this._saveInGlobalState
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectBetween)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.coverage.taxable),
          selected: data.isTaxable === true,
          field: 'isTaxable'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.coverage.nonTaxable),
          selected: data.isTaxable === false,
          field: 'isTaxable'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('isTaxable', !data.isTaxable);
        }
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allowPreExistingConditions),
        isSelected: data.includeAllowPreExistingConditions,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeAllowPreExistingConditions", !data.includeAllowPreExistingConditions);
        }
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allowCostOfLivingAdjustments),
        isSelected: data.includeCostOfLivingAdjustments,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeCostOfLivingAdjustments", !data.includeCostOfLivingAdjustments);
        }
      }))), data.includeCostOfLivingAdjustments && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.costOfLivingAdjustmentPercentage),
        fullWidth: true,
        variant: "outlined",
        value: data.costOfLivingAdjustmentsPercentage,
        onChange: function onChange(e) {
          return _this2._handleChange("costOfLivingAdjustmentsPercentage", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("costOfLivingAdjustmentsPercentage", e.target.value);
        },
        error: errors.costOfLivingAdjustmentsPercentage,
        select: true,
        selectOptions: [{
          key: 1,
          value: 1
        }, {
          key: 2,
          value: 2
        }, {
          key: 3,
          value: 3
        }, {
          key: 4,
          value: 4
        }, {
          key: 5,
          value: 5
        }, {
          key: 6,
          value: 6
        }, {
          key: 7,
          value: 7
        }, {
          key: 8,
          value: 8
        }, {
          key: 9,
          value: 9
        }]
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allowLumpSumPayment),
        isSelected: data.includeLumpSumPaymentDisabledParticipantsDeath,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeLumpSumPaymentDisabledParticipantsDeath", !data.includeLumpSumPaymentDisabledParticipantsDeath);
        }
      }))), !data.isGraded && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 24
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.percentageOfFlatAmount),
        fullWidth: true,
        suffix: "%",
        value: data.percentageOfFlatAmount,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("percentageOfFlatAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("percentageOfFlatAmount", e.target.value);
        },
        error: errors.percentageOfFlatAmount
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), data.isGraded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.percentageOfFirstMaximum),
        fullWidth: true,
        value: data.percentageFirstMax,
        variant: "outlined",
        suffix: "%",
        onChange: function onChange(e) {
          return _this2._handleChange("percentageFirstMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("percentageFirstMax", e.target.value);
        },
        error: errors.percentageFirstMax
      })), data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.percentageOfSecondMaximum),
        fullWidth: true,
        value: data.percentageSecondMax,
        variant: "outlined",
        suffix: "%",
        onChange: function onChange(e) {
          return _this2._handleChange("percentageSecondMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("percentageSecondMax", e.target.value);
        },
        error: errors.percentageSecondMax
      })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.percentageOfThirdMaximum),
        fullWidth: true,
        value: data.percentageThirdMax,
        variant: "outlined",
        suffix: "%",
        onChange: function onChange(e) {
          return _this2._handleChange("percentageThirdMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("percentageThirdMax", e.target.value);
        },
        error: errors.percentageThirdMax
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.firstMaximumType),
        fullWidth: true,
        value: localizationMaps.fromEnglish('planMaximumOptions', data.firstMaxType),
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("firstMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("firstMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        error: errors.firstMaxType,
        select: true,
        selectOptions: _services.selectFieldOptions.planMaximumOptions()
      })), data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.secondMaximumType),
        fullWidth: true,
        value: localizationMaps.fromEnglish('planMaximumOptions', data.secondMaxType),
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("secondMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("secondMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        error: errors.secondMaxType,
        select: true,
        selectOptions: _services.selectFieldOptions.planMaximumOptions()
      })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.thirdMaximumType),
        fullWidth: true,
        value: localizationMaps.fromEnglish('planMaximumOptions', data.thirdMaxType),
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("thirdMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("thirdMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value));
        },
        error: errors.thirdMaxType,
        select: true,
        selectOptions: _services.selectFieldOptions.planMaximumOptions()
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.firstMaximum),
        fullWidth: true,
        value: data.firstMax,
        variant: "outlined",
        prefix: "$ ",
        onChange: function onChange(e) {
          return _this2._handleChange("firstMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("firstMax", e.target.value);
        },
        error: errors.firstMax
      })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.secondMaximum),
        fullWidth: true,
        value: data.secondMax,
        variant: "outlined",
        prefix: "$ ",
        onChange: function onChange(e) {
          return _this2._handleChange("secondMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("secondMax", e.target.value);
        },
        error: errors.secondMax
      })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && data.thirdMaxType === 'Dollar Amount' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.thirdMaximum),
        fullWidth: true,
        value: data.thirdMax,
        variant: "outlined",
        prefix: "$ ",
        onChange: function onChange(e) {
          return _this2._handleChange("thirdMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("thirdMax", e.target.value);
        },
        error: errors.thirdMax
      })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.nonEvidenceMaximum),
        fullWidth: true,
        prefix: "$ ",
        disabled: !isMasterSite,
        value: data.maxNoEvidence,
        onChange: function onChange(e) {
          return _this2._handleChange("maxNoEvidence", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxNoEvidence", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.maximumWithEvidence),
        fullWidth: true,
        prefix: "$ ",
        disabled: !isMasterSite,
        value: data.maxEvidence,
        onChange: function onChange(e) {
          return _this2._handleChange("maxEvidence", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxEvidence", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.benefitsPeriod),
        fullWidth: true,
        value: localizationMaps.fromEnglish('benefitsPeriod', data.benefitsPeriod),
        variant: "outlined",
        onChange: ( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
            var value;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  value = e.target.value;
                  _context.next = 3;
                  return _this2._handleChange("benefitsPeriod", localizationMaps.toEnglish('benefitsPeriod', value));
                case 3:
                  if (localizationMaps.toEnglish("benefitsPeriod", value) === '2 Years') {
                    _this2._handleChange("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
                  } else if (localizationMaps.toEnglish("benefitsPeriod", value) === '5 Years') {
                    _this2._handleChange("defOfDisability", '5 Year Own Occupation, Any Occupation Thereafter');
                  } else {
                    _this2._handleChange("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
                  }
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()),
        onBlur: ( /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(e) {
            var value;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  value = e.target.value;
                  _context2.next = 3;
                  return _this2._saveInGlobalState("benefitsPeriod", localizationMaps.toEnglish('benefitsPeriod', value));
                case 3:
                  if (localizationMaps.toEnglish("benefitsPeriod", value) === '2 Years') {
                    _this2._saveInGlobalState("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
                  } else if (localizationMaps.toEnglish("benefitsPeriod", value) === '5 Years') {
                    _this2._saveInGlobalState("defOfDisability", '5 Year Own Occupation, Any Occupation Thereafter');
                  } else {
                    _this2._saveInGlobalState("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
                  }
                case 4:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }()),
        error: errors.benefitsPeriod,
        select: true,
        selectOptions: _services.selectFieldOptions.defOfDisabilityOptions()
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eliminationPeriodDays),
        fullWidth: true,
        value: parseInt(data.elimPeriod, 10),
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("elimPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("elimPeriod", e.target.value);
        },
        error: errors.elimPeriod,
        select: true,
        selectOptions: [{
          key: 0,
          value: 91
        }, {
          key: 1,
          value: 105
        }, {
          key: 2,
          value: 112
        }, {
          key: 3,
          value: 116
        }, {
          key: 4,
          value: 119
        }, {
          key: 5,
          value: 120
        }, {
          key: 6,
          value: 121
        }, {
          key: 7,
          value: 182
        }]
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 8
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.definitionOfDisability),
        fullWidth: true,
        value: localizationMaps.fromEnglish('defOfDisability', data.defOfDisability),
        variant: "outlined",
        disabled: !isMasterSite,
        onChange: function onChange(e) {
          return _this2._handleChange("defOfDisability", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("defOfDisability", e.target.value);
        },
        select: true,
        selectOptions: _services.selectFieldOptions.defOfDisabilityMapOptions()
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planEligibilityTermination)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eligibilityPeriodMonths),
        fullWidth: true,
        value: data.eligibilityPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eligibilityPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eligibilityPeriod", e.target.value);
        },
        error: errors.eligibilityPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.minimumHoursPerWeek),
        fullWidth: true,
        value: data.minHoursPerWeek,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("minHoursPerWeek", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("minHoursPerWeek", e.target.value);
        },
        error: errors.minHoursPerWeek
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.terminationAge),
        fullWidth: true,
        value: data.terminationAge,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("terminationAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("terminationAge", e.target.value);
        },
        error: errors.terminationAge
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        margin: "20px 0 0 0",
        bold: true
      }, "Notes:"), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        fullWidth: true,
        value: data.notes || '',
        variant: "outlined",
        error: errors.notes,
        onChange: function onChange(e) {
          return _this2._handleChange("notes", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("notes", e.target.value);
        },
        multiline: true,
        rows: 5,
        placeholder: _i18n["default"].t(_tokens["default"].labels.planDesign.additionalRequestsInformation)
      })));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = LTD;